import React from 'react';
import {Table, Header, Segment, Loader, Message, Grid, Divider, Icon} from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { ToastContainer } from 'react-toastify';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

const NoDataMessage = () => <p>{<FormattedMessage id="professorInputGrades.NoUpcomingExamsMessage" />}</p>;


export default class StudentUpcomingExams extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            showPreviousNotices: false,

            loading: false,
            error: false,
        };

        this.getExams = this.getExams.bind(this);
    }

    componentDidMount() {
        this.getExams();
    }

    getExams() {
        axios.get('/student-exams/registration/registered/false')
            .then(res => {
                const data = res.data.map(el => ({
                    ...el,
                    date: moment(el.examDate).format('D. M. YYYY. - HH:mm')
                }));
                this.setState({ data, loading: false });
            })
            .catch(err => {
                console.log('Failed to fetch upcoming exams');
                this.setState({ error: true });
            });
    }


    render() {
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        const { data, showPreviousNotices } = this.state;

        return (
            <div>
                <Grid columns="equal" centered className="stackable">
                    <Grid.Row stretched>
                        <Grid.Column>
                            <Segment.Group raised style={{ backgroundColor: 'white' }}>
                                <Segment>
                                    <Header as="h3">
                                        {<FormattedMessage id="professorInputGrades.upcomingExamsList" />}
                                    </Header>
                                </Segment>

                                <Segment>
                                    {data.length ?
                                        <Table tablet stackable celled selectable compact>
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell>{<FormattedMessage id="common.courseName" />}</Table.HeaderCell>
                                                    <Table.HeaderCell>{<FormattedMessage id="professorInputGrades.examDateDate" />}</Table.HeaderCell>
                                                    <Table.HeaderCell>{<FormattedMessage id="common.teacher" />}</Table.HeaderCell>
                                                    <Table.HeaderCell>{<FormattedMessage id="common.classroom" />}</Table.HeaderCell>
                                                    <Table.HeaderCell>{<FormattedMessage id="common.comment" />}</Table.HeaderCell>

                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body> {data.map(el =>
                                                (<Table.Row key={el.gradedActivityId}>
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.courseName}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.date}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.teacherName}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.classroom}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.comment}
                                                    </Table.Cell>
                                                </Table.Row>))}
                                            </Table.Body>
                                        </Table>

                                        : <NoDataMessage />

                                    }
                                </Segment>
                                <ToastContainer hideProgressBar />
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentCoursesOverview/StudentUpcomingExams.js